import { styled } from "@mui/material/styles";
import Typography from "@mui/material/Typography/Typography";

export const PageHeading = styled(Typography)`
    font-size: 32px;
`;